// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CallAudioButton__check-icon-ab843f {
  margin-inline-start: 8px;
}

.CallAudioButton__menu-title-e6802b {
  font: var(--font-body-4);
  color: var(--addition-50_70);
  opacity: 1 !important;
  letter-spacing: var(--font-spacing-body-4);
}

.CallAudioButton__menu-title-e6802b:hover,
.CallAudioButton__menu-title-e6802b:focus,
.CallAudioButton__menu-title-e6802b:active {
  background-color: transparent;
}

.CallAudioButton__audio-menu-title-f8f9ef {
  margin-top: 8px;
}

.CallAudioButton__popover-d570e1 {
  background-color: var(--light-10-addition-120);
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/Shared/CallActionsPanel/CallAudioButton/CallAudioButton.styles.m.css"],"names":[],"mappings":"AAAA;EACE,wBAAA;AACF;;AAEA;EACE,wBAAA;EACA,4BAAA;EACA,qBAAA;EACA,0CAAA;AACF;;AAEA;;;EAGE,6BAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,8CAAA;AACF","sourcesContent":[".check-icon {\n  margin-inline-start: 8px;\n}\n\n.menu-title {\n  font: var(--font-body-4);\n  color: var(--addition-50_70);\n  opacity: 1 !important;\n  letter-spacing: var(--font-spacing-body-4);\n}\n\n.menu-title:hover,\n.menu-title:focus,\n.menu-title:active {\n  background-color: transparent;\n}\n\n.audio-menu-title {\n  margin-top: 8px;\n}\n\n.popover {\n  background-color: var(--light-10-addition-120);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"check-icon": `CallAudioButton__check-icon-ab843f`,
	"checkIcon": `CallAudioButton__check-icon-ab843f`,
	"menu-title": `CallAudioButton__menu-title-e6802b`,
	"menuTitle": `CallAudioButton__menu-title-e6802b`,
	"audio-menu-title": `CallAudioButton__audio-menu-title-f8f9ef`,
	"audioMenuTitle": `CallAudioButton__audio-menu-title-f8f9ef`,
	"popover": `CallAudioButton__popover-d570e1`
};
module.exports = ___CSS_LOADER_EXPORT___;
